export default function useGetProtocolHost(): string {
  // 로컬에서 개발하는 경우에는 proxy 서버 사용을 위해 http://localhost:8080으로 api를 호출한다.
  // 로컬이 아닌 개발/운영/스테이지 환경에서는 env 파일에 있는 VUE_APP_API_URL 값을 바라보도록 한다.
  return location.hostname === "localhost"
    ? `${location.protocol}//${location.host}`
    : process.env.VUE_APP_API_URL!;
}
